var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chapter-list"},[_c('ul',_vm._l((_vm.data.list),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item.content))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }